/**
 *
 * @author Atish Bagate
 */

interface CreatePatientSocialHistoryParams {
  patientQuestionAnswerRequest: PatientQuestionAnswerRequest;
  xTENANTID?: string;
}

import {
  PatientQuestionAnswerRequest,
  PatientSocialHistoryControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

export const useCreatePatientSocialHistory = () =>
  useMutationWithLoading(
    async ({
      patientQuestionAnswerRequest,
      xTENANTID,
    }: CreatePatientSocialHistoryParams) =>
      new PatientSocialHistoryControllerApi(
        getConfigObject()
      ).createPatientSocialHistory(patientQuestionAnswerRequest, xTENANTID)
  );
